import { render } from "./DatastoreDocumentation.vue?vue&type=template&id=62da0044&scoped=true"
import script from "./DatastoreDocumentation.vue?vue&type=script&lang=js"
export * from "./DatastoreDocumentation.vue?vue&type=script&lang=js"

import "./DatastoreDocumentation.vue?vue&type=style&index=0&id=62da0044&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62da0044"]])

export default __exports__